import * as React from "react";
import type { FC, PropsWithChildren } from "react";

import { isKnownErrorTag } from "../../../../../../../../Common/CandyApiClient/Types/ErrorLog/Tags/KnownErrorTag";

import { ErrorItemMinitour } from "./ErrorItemMinitour";

export const Minitour: FC<PropsWithChildren<{ tags: string[] }>> = ({ tags, children }) =>
    tags.reduce(
        (acc, tag) => {
            if (isKnownErrorTag(tag)) {
                return <ErrorItemMinitour tag={tag}>{acc}</ErrorItemMinitour>;
            } else {
                return <>{acc}</>;
            }
        },
        <>{children}</>
    );
